module.exports = __webpack_public_path__ + "static/media/car360-black.8fd2dc41.svg";